var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgSparkle = function SvgSparkle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98966 15.5886C7.77479 11.3638 4.27711 8 0 8C4.28139 7.89156 7.66432 4.68389 7.98966 0.411416L8 0C8 4.41529 11.5847 8 16 8C11.5847 8 8 11.5847 8 16L7.98966 15.5886Z",
    fill: "url(#paint0_linear_3241_14855)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3241_14855",
    x1: 16,
    y1: 16,
    x2: -1.37704,
    y2: 15.2633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846071,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE27B"
  })))));
};
var Memo = /*#__PURE__*/memo(SvgSparkle);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/sparkle.195bfdf33b54e9291d41c87d514b3c2f.svg";